export const unmask = (val) => val.replace(/[$, ]+/g, '');

export function numberUnmask(val) {
  return val.match(/\d+/g).join('');
}

export function floatUnmask(val) {
  return val.match(/[\d.]+/g).join('');
}
